module.exports = __webpack_public_path__ + "static/community-relations-2-0c4f99e2e111b4585f7fcd41fbd8157f.jpg";